import React, { useState, useEffect, useRef } from "react";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import { getDataFromAPICreateCombo } from "./action";
import { useNavigate } from "react-router-dom";
import ComboCreateComponent from "./component";
import debounce from "lodash.debounce";
import moment from "moment";
import axios from "axios";
import { toast } from "react-toastify";

const ComboCreateContainer = (props) => {
  console.log("ComboCreateContainer", props)
  const navigate = useNavigate();
  const [offset, setOffset] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [retail_price, setretail_price] = useState("");
  const [offer_price, setoffer_price] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [file, setFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const [applyOnKiosk, setApplyOnKiosk] = useState(false);
  const [applyOnConsumerApp, setApplyOnConsumerApp] = useState(false);
  const [mvConfig, setMvConfig] = useState([]);
  const [mvIdList, setMvIdList] = useState([]);
  const [mvId, setMvId] = useState("");
  const [selectedMvId, setSelectedMvId] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedMvItems, setSelectedMvItems] = useState([]);
  const [errors, setErrors] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [imagePath, setImagePath] = useState(null);
  const [isImageUploaded, setIsImageUploaded] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [price, setPrice] = useState("");
  const [hasMoreData, setHasMoreData] = useState(true);
  const tableContainerRef = useRef(null);

  const filteredMvIdList = Array.isArray(mvIdList)
    ? mvIdList.filter(
      (item) =>
        (item.id &&
          item.id.toString().toLowerCase().includes(searchQuery.toLowerCase())) ||
        (item.variant_name &&
          item.variant_name.toLowerCase().includes(searchQuery.toLowerCase()))
    )
    : [];


  const handleShowSuccessModal = () => {
    setSuccessModalOpen(true);
  };

  const handleCloseSuccessModal = () => {
    setSuccessModalOpen(false);
    navigate(-1);
  };

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleSelectMvId = (item) => {
    setSelectedMvItems((prevSelected) => {
      if (prevSelected.some((selectedItem) => selectedItem.id === item.id)) {
        return prevSelected;
      }
      return [...prevSelected, { ...item, quantity: 1 }];
    });
    setMvId("");
    handleCloseModal();
  };

  const handleQuantityChange = (id, newQuantity) => {
    setSelectedMvItems((prevSelected) =>
      prevSelected.map((item) =>
        item.id === id ? { ...item, quantity: newQuantity } : item
      )
    );
  };

  const incrementQuantity = (id) => {
    setSelectedMvItems((prevSelected) =>
      prevSelected.map((item) =>
        item.id === id ? { ...item, quantity: item.quantity + 1 } : item
      )
    );
  };

  const decrementQuantity = (id) => {
    setSelectedMvItems((prevSelected) => {
      const updatedItems = prevSelected.map((item) =>
        item.id === id
          ? {
            ...item,
            quantity: item.quantity > 0 ? item.quantity - 1 : item.quantity,
          }
          : item
      );

      return updatedItems.filter((item) => item.quantity > 0);
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const allowedTypes = [
        "image/jpeg",
        "image/png",
        "image/gif",
        "image/webp",
      ];
      const allowedExtensions = [".jpg", ".jpeg", ".png", ".gif", ".webp"];
      const fileExtension = file.name
        .substring(file.name.lastIndexOf("."))
        .toLowerCase();

      if (
        !allowedTypes.includes(file.type) ||
        !allowedExtensions.includes(fileExtension)
      ) {
        toastr.error(
          "Error",
          "Only image files are allowed (JPG, PNG, GIF, WEBP)"
        );
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);

      setSelectedFile(file);
    } else {
      setImagePreview(null);
    }
  };

  const handleImageUpload = () => {
    if (!selectedFile) {
      toastr.error("Error", "Please select an image");
      return;
    }

    const formData = new FormData();
    formData.append("image_file", selectedFile);
    formData.append("image_type", "combo");
    console.log("selected file", selectedFile);

    props.getDataFromAPI(
      `/dashboard/api/v2/admin/screensaver/upload`,
      "POST",
      formData,
      (response) => {
        toastr.success("Created", "Image uploaded successfully");
        setFilePreview(null);
        setImagePath(response.screenSaverUrl);
        setIsImageUploaded(true);
      },
      (err) => {
        toastr.error("Failed", "Unable to upload image");
      }
    );
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
    setImagePreview(null);
  };

  const submitApiButton = () => {
    handleCreateComboApi();
  };

  const validateComboForm = (data) => {
    const errors = {};
    const invalidCharsRegex = /[^a-zA-Z0-9\s]/;
    const numberPattern = /^\d*$/;
    const whitespaceOnlyPattern = /^\s*$/;
    const pricePattern = /^(?!0$)[0-9]{1,6}$/;

    const {
      name,
      description,
      retail_price,
      offer_price,
      startDate,
      endDate,
      applyOnKiosk,
      applyOnConsumerApp,
      selectedMvItems,
    } = data;

    if (!name || whitespaceOnlyPattern.test(name)) {
      errors.name = "Name is required and cannot be empty or whitespace";
    } else if (name.length < 3) {
      errors.name = "Name must be at least 3 characters";
    }

    if (!description || whitespaceOnlyPattern.test(description)) {
      errors.description =
        "Description is required and cannot be empty or whitespace";
    }

    if (!retail_price || !pricePattern.test(retail_price)) {
      errors.retail_price = "Selling price must be a number";
    } else if (whitespaceOnlyPattern.test(retail_price)) {
      errors.retail_price = "Selling price cannot be empty or whitespace";
    }

    if (!offer_price || !pricePattern.test(offer_price)) {
      errors.offer_price = "Offer price must be a number";
    } else if (whitespaceOnlyPattern.test(offer_price)) {
      errors.offer_price = "Offer price cannot be empty or whitespace";
    }

    const currentUtc = moment().utc();
    const startDateUtc = moment(startDate).utc();
    const endDateUtc = moment(endDate).utc();

    if (!startDate || startDateUtc.isBefore(currentUtc)) {
      errors.date = "Start date cannot be in the past";
    } else if (!endDate || startDateUtc.isSameOrAfter(endDateUtc)) {
      errors.date = "Start date must be before the end date";
    }

    if (!applyOnKiosk && !applyOnConsumerApp) {
      errors.selection = "Select at least one application";
    }

    if (selectedMvItems.length === 0) {
      errors.mvConfig = "Please select at least one MV ID";
    } else {
      const totalMvPrice = selectedMvItems.reduce(
        (sum, item) => sum + (item.price || 0) * (item.quantity || 1),
        0
      );

      if (totalMvPrice !== parseInt(offer_price, 10)) {
        errors.mvConfig = `The total price of selected MV items (${totalMvPrice}) must match the offer price (${offer_price})`;
      }
    }

    return errors;
  };

  const handleCreateComboApi = async () => {

    const data = {
      name,
      description,
      retail_price,
      offer_price,
      startDate,
      endDate,
      applyOnKiosk,
      applyOnConsumerApp,
      selectedMvItems,
    };

    const errors = validateComboForm(data);
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }
    setErrors({});
    const startDateUtc = moment
      .tz(startDate, "Your Time Zone")
      .utc()
      .toISOString();
    const endDateUtc = moment.tz(endDate, "Your Time Zone").utc().toISOString();
    const mvConfig = selectedMvItems.map((item) => ({
      mv_id: item.id,
      quantity: item.quantity,
      price: item.price,
    }));

    const payload = {
      name: name,
      description: description,
      total_price: parseInt(offer_price),
      actual_price: parseInt(retail_price),
      activates_at: startDateUtc,
      expires_at: endDateUtc,
      consumer_app_enabled: applyOnConsumerApp,
      kiosk_app_enabled: applyOnKiosk,
      image_url: imagePath,
      mv_config: mvConfig,
      combo_cohorts: [],
    };

    try {

      const response = await props.getDataFromAPICreateCombo(
        `/partner/api/v2/combo/create`,
        "POST",
        payload,
        (response) => {
          console.log(" res", response.status.code)
          if (response.status == "200") {
            navigate("/home/combolist")
            toastr.success("combo created");
          }
        },
        (err) => {
                  console.log(" create err combo1 api ", err.status.code);
                  // toast.error(`${   "Error",err.status.message}`, {
                  //   position: "top-right",
                  //   autoClose: 1000,
                  // });
                }
      );
    } catch (err) {
              console.log(" create err combo2 api ", err.status.message);
              // toast.error(`${   "Error",err.status.message}`, {
              //   position: "top-right",
              //   autoClose: 1000,
              // });
            }
  };


  useEffect(() => {
    const fetchInitialData = () => {
      props.getDataFromAPI(
        `/dashboard/api/v2/admin/mvs/all?limit=50&isActive=1&offset=0`,
        "GET",
        undefined,
        (response) => {
          const list = response?.list || [];
          setMvIdList(list);
          setFilteredMvList(list);
          setHasMoreData(list.length === 30);
        },
        (err) => {
          console.error("API Error:", err);
        }
      );
    };

    fetchInitialData();
  }, []);

  // const handleScrollMvIdApi = () => {
  //   if (isLoading || !hasMoreData) return;

  //   setIsLoading(true);
  //   console.log(`Fetching data with offset: ${offset}`);

  //   props.getDataFromAPI(
  //     `/dashboard/api/v2/admin/mvs/all?limit=100&isActive=1&offset=${offset}`,
  //     "GET",
  //     undefined,
  //     (response) => {
  //       const newItems = response?.list || [];
  //       setMvIdList((prevList) => [...prevList, ...newItems]);
  //       setFilteredMvList((prevList) => [...prevList, ...newItems]);
  //       setOffset((prevOffset) => prevOffset + 1);
  //       setHasMoreData(newItems.length === 30);
  //       setIsLoading(false);
  //     },
  //     (err) => {
  //       console.error("API Error:", err);
  //       setIsLoading(false);
  //     }
  //   );
  // };

  // // Scroll Logic
  // useEffect(() => {
  //   const handleScroll = () => {
  //     const container = tableContainerRef.current;

  //     if (!container) {
  //       console.warn("Scroll container not found.");
  //       return;
  //     }

  //     const { scrollTop, scrollHeight, clientHeight } = container;
  //     console.log({ scrollTop, scrollHeight, clientHeight }); // Debugging scroll values

  //     if (scrollHeight - scrollTop <= clientHeight + 50 && !isLoading) {
  //       console.log("Fetching more data...");
  //       handleScrollMvIdApi();
  //     }
  //   };

  //   const container = tableContainerRef.current;
  //   if (container) {
  //     container.addEventListener("scroll", handleScroll);
  //   }

  //   return () => {
  //     if (container) {
  //       container.removeEventListener("scroll", handleScroll);
  //     }
  //   };
  // }, [isLoading, hasMoreData, offset]);

  const [filteredMvList, setFilteredMvList] = useState([]);

  const handleSearchMvId = debounce((query = "") => {
    console.log("Search Query:", query);
    if (query.trim() === "") {
      setFilteredMvList(mvIdList);
      return;
    }

    props.getDataFromAPI(
      `/dashboard/api/v2/admin/mvs/all?limit=50&offset=0&isActive=1&search=${query}`,
      "GET",
      undefined,
      (response) => {
        console.log("Search Response:", response?.list || []);
        setFilteredMvList(response?.list || []);
      },
      (err) => {
        console.error("API Error:", err);
      }
    );
  }, 300);

  const handleSearchQueryChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    handleSearchMvId(value);
  };

  return (
    <ComboCreateComponent
      isLoading={isLoading}
      name={name}
      description={description}
      retail_price={retail_price}
      offer_price={offer_price}
      startDate={startDate}
      endDate={endDate}
      file={file}
      imagePreview={imagePreview}
      applyOnKiosk={applyOnKiosk}
      applyOnConsumerApp={applyOnConsumerApp}
      mvConfig={mvConfig}
      setName={setName}
      setDescription={setDescription}
      setretail_price={setretail_price}
      setoffer_price={setoffer_price}
      setStartDate={setStartDate}
      setEndDate={setEndDate}
      setFile={setFile}
      setApplyOnKiosk={setApplyOnKiosk}
      setApplyOnConsumerApp={setApplyOnConsumerApp}
      handleQuantityChange={handleQuantityChange}
      handleFileChange={handleFileChange}
      incrementQuantity={incrementQuantity}
      handleRemoveFile={handleRemoveFile}
      handleCreateComboApi={handleCreateComboApi}
      mvIdList={mvIdList}
      setMvId={setMvId}
      modalOpen={modalOpen}
      setModalOpen={setModalOpen}
      selectedMvId={setSelectedMvId}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      filteredMvIdList={filteredMvIdList}
      handleOpenModal={handleOpenModal}
      handleSelectMvId={handleSelectMvId}
      handleCloseModal={handleCloseModal}
      decrementQuantity={decrementQuantity}
      setSelectedMvItems={setSelectedMvItems}
      selectedMvItems={selectedMvItems}
      errors={errors}
      successModalOpen={successModalOpen}
      handleCloseSuccessModal={handleCloseSuccessModal}
      handleImageUpload={handleImageUpload}
      selectedFile={selectedFile}
      isImageUploaded={isImageUploaded}
      price={price}
      setPrice={setPrice}
      handleSearchQueryChange={handleSearchQueryChange}
      filteredMvList={filteredMvList}
      submitApiButton={submitApiButton}
      tableContainerRef={tableContainerRef}
      hasMoreData={hasMoreData}
    />
  );
};

function mapStateToProps(props) {
  return {
    props,
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
  getDataFromAPICreateCombo,
})(ComboCreateContainer);
